import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import Typography from '../../components/common/Typography';
import Button from '../../components/common/Button';
import { FindPasswordButton } from '../../components/common/FullButton';
import { maskId } from '../../common/Util';
import { HtmIdFind } from './findByPasswordSlice';
import { setSelectedInsuranceDetail } from '../deductions/insurancePremiums/insuranceSlice';

const Step2 = ({stepHandler}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('findPassword');
  const { t: tCommon } = useTranslation('common');
  const { idList } = useSelector(state => state.findByPassword);

  const handleClick = item => {
    let data = {
      htmMCd: item.htmMCd,
      htmSCd: item.htmSCd,
    };
    dispatch(HtmIdFind(data));
  };

  return (
    <>
      <div className="displayFlexColumn" style={{ gap: '8px' }}>
        <Typography variant="subtitleBold">{t('step2.title')}</Typography>
        <Typography variant="body2Medium" style={{ whiteSpace: 'pre-wrap' }}>
          {t('step2.description')}
        </Typography>
      </div>
      {/*  */}
      <div className="displayFlexColumn" style={{ gap: '8px' }}>
        {idList.map((item, index) => (
          <FindPasswordButton
            key={index}
            title={maskId(item.htmComId)}
            description={`회사아이디 : ${item.htmComCd}\r\n회사명 : ${item.htmComNm}`}
            icon="arrow"
            onClick={() => handleClick(item)}
          />
        ))}
      </div>
      <div className="displayFlexColumn" style={{ gap: '10px' }}>
        {/* <Button value={tCommon('confirm')} fullWidth onClick={() => stepHandler(3)} /> */}
        <Button color="sub" value={tCommon('cancel2')} fullWidth onClick={() => stepHandler(1)} />
      </div>
    </>
  );
};

export default Step2;
